import { render, staticRenderFns } from "./point-of-sale-detail.vue?vue&type=template&id=4a21c539"
import script from "./point-of-sale-detail.vue?vue&type=script&lang=js"
export * from "./point-of-sale-detail.vue?vue&type=script&lang=js"
import style0 from "./point-of-sale-detail.vue?vue&type=style&index=0&id=4a21c539&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports